import React from "react"
import { Table } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import { browserHistory } from "react-router"
import AlertModal from "../../fragments/AlertModal"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { blockingFetchService } from "../../../lib/blockingFetch"
import BusinessLink from "../../fragments/BusinessLink"
import CaptionTable from "../../fragments/CaptionTable"
import { fillingZeroUtility, formatCurrency } from "../../../lib/utils"

const className = 'cursor-pointer',
title = 'Show details'

export default class BucketBatches extends React.Component {

  state = {
    batchId: null,
    running: false,
    success: false,
    error: null,
  }

  unlinkBatch = batchId => this.setState({
    batchId,
    running: false,
    success: false,
    error: null,
  })

  confirmForm = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { bucketId, setFinancierBucket } = this.props,
    { batchId } = this.state

    blockingFetchService(
      accessToken => apiServerApi.removeBatchFinancierBucket(accessToken, bucketId, batchId),
      resp => {
        this.setState({ success: true })
        setTimeout(this.closeForm, 1000)
        setFinancierBucket(bucketId, resp)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeForm = () => this.setState({ batchId: null })

  renderConfirmContent = () => {
    const { running, success, error } = this.state
    return (
      <div>
        <h3>Do you really want to unlink this batch?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderThs = isLarge => <tr>
    <th>Name</th>

    { isLarge && <th>Affiliation</th> }

    { isLarge && <th>Currency code</th> }

    <th>Purchase cost</th>

    <th>Selling price</th>

    { isLarge && <th>Other costs</th> }

    { isLarge && <th>Closed</th> }

    <th className="align-center">Action</th>
  </tr>

  getData = (batches, isLarge, bucketClosed) => batches
  .map(({ id, name, affiliation = {}, closed, purchaseCost, sellingCost, currencyCode,
    commissionFee, transportFee }, index) => {

    const onClick = () => browserHistory.push(`/financiers/batches/${id}/detail`),

    { id: affId, name: affName, businessId } = affiliation,

    otherCosts = commissionFee + transportFee

    return <tr key={`small-batch-${index}`} title={ title } className={ className }>
      <td onClick={ onClick }>{ name }</td>

      { isLarge && <td title="Show affiliation">
        { !!affId && <BusinessLink id={ affId } name={ affName } businessId={ businessId } /> }
      </td> }

      { isLarge && <td onClick={ onClick }>{ currencyCode }</td> }

      <td onClick={ onClick }>{ formatCurrency(purchaseCost) }</td>

      <td onClick={ onClick }>{ formatCurrency(sellingCost) }</td>
  
      { isLarge && <td onClick={ onClick }>{ formatCurrency(otherCosts) }</td> }

      { isLarge && <td onClick={ onClick }>
        <small className="gray">{ closed ? 'Yes' : 'No' }</small>
      </td> }

      <td className="align-center">
        { !bucketClosed && <span className="red cursor-pointer p-5" title="Unlink this batch!"
          onClick={() => this.unlinkBatch(id) }>
          <FontAwesome name='trash' />
        </span>}
      </td>
    </tr>
  })

  render() {

    const { batches, isLarge, closed } = this.props
    if(!batches || !batches.length) return null

    const { batchId, running } = this.state

    return (
      <div>
 
        <Table striped condensed hover responsive>

          <CaptionTable text={`Batches (${ fillingZeroUtility(batches.length) })`} />

          <tbody>
            { this.renderThs(isLarge) }
            { this.getData(batches, isLarge, closed) }
          </tbody>
        </Table>

        <AlertModal
          show={ batchId != null }
          title="Unlink batch"
          body={ this.renderConfirmContent() }
          bsStyle="danger"
          close={ this.closeForm }
          confirm={ this.confirmForm }
          proceedText="Unlink"
          disabled={ running }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/BucketBatches.js